// Card model shared between game-engine, server and web client.
// Suit names are the engine's internal (English) vocabulary; the web client
// maps these to the visual asset filenames (karo/srce/tref/list) — see
// apps/web/src/cards/assets.ts. The engine itself must stay asset-agnostic.

export const SUITS = ["diamonds", "hearts", "clubs", "leaves"] as const;
export type Suit = (typeof SUITS)[number];

// 7 < 8 < 9 < 10 < J(11) < Q(12) < K(13) < A(14)
export const RANKS = [7, 8, 9, 10, 11, 12, 13, 14] as const;
export type Rank = (typeof RANKS)[number];

export interface Card {
  suit: Suit;
  rank: Rank;
}

export type CardId = string; // `${suit}:${rank}`

export function cardId(card: Card): CardId {
  return `${card.suit}:${card.rank}`;
}

export function parseCardId(id: CardId): Card {
  const [suit, rankStr] = id.split(":");
  const rank = Number(rankStr) as Rank;
  if (!SUITS.includes(suit as Suit) || !RANKS.includes(rank)) {
    throw new Error(`Invalid card id: ${id}`);
  }
  return { suit: suit as Suit, rank };
}

export function makeDeck(): Card[] {
  const deck: Card[] = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push({ suit, rank });
    }
  }
  return deck;
}

export function cardsEqual(a: Card, b: Card): boolean {
  return a.suit === b.suit && a.rank === b.rank;
}
